// DialogPurchaseOrderOpen Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import currency from '../../../lib/currency.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import AddressSelect from '../../../common/form/address_select/address_select.jsx'
import Select from '../../../common/form/select/select.jsx'

class DialogPurchaseOrderOpen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      showError: false,
      total: '',
      contactName: '',
      dataDate: null,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      onEditAddress: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      onEditAddress: null
    }
  }

  show (poObj) {
    FabButtonManager.setVisible(false)
    if (poObj) {
      this.setState({
        total: poObj.total,
        contactName: poObj.contactName,
        contactPersonOptions: poObj.contactPersonOptions,
        contactPersonId: poObj.contactPerson,
        addressOptions: poObj.addressOptions ? poObj.addressOptions : [],
        addresses: poObj.addresses ? poObj.addresses : null,
        address: poObj.contactAddress,
        dataDate: new Date()
      })
    }
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      total: '',
      contactName: '',
      showError: false,
      contactPersonOptions: [],
      contactPersonId: '',
      addressOptions: [],
      addresses: [],
      address: null
    })
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  }

  render () {
    const address = this.state.address
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'

    return (
      <Dialog active={this.state.active} onClose={this.hide.bind(this)}>
        <div className='dialog-form invoicefinalize-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='purchaseOrder.form.openTitle' />
                <span className='subtitle'>
                  <IntlMessage ident='purchaseOrder.form.openSubTitle' />
                </span>
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='purchaseOrder.form.openErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  {this.state.contactPersonOptions &&
                    this.state.contactPersonOptions.length > 0 && (
                      <div className='formrow'>
                        <div className='formcol'>
                          <Select
                            options={this.state.contactPersonOptions}
                            name='contactPersonId'
                            className='form-dropdown'
                            label='purchaseOrder.form.labelContactPerson'
                            value={this.state.contactPersonId}
                            onChange={this._onChangeInput.bind(
                              this,
                              'contactPersonId'
                            )}
                          />
                        </div>
                      </div>
                    )}
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <AddressSelect
                          addressOptions={this.state.addressOptions}
                          address={address}
                          onSelectAddress={this._onSelectAddress.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='formsection'>&nbsp;</div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='purchaseOrder.form.tipSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
          <div className='dialogform-footer'>
            <div className='formrow'>
              <div className='formcol'>
                <div className='totalinfo'>
                  <span className='title'>
                    <IntlMessage ident='purchaseOrder.form.titlePriceExcl' />
                  </span>
                  <div className='content'>
                    <h2 className='infovalue'>
                      {this.state.total
                        ? currency.formatSymbol(this.state.total)
                        : '-'}
                    </h2>
                  </div>
                </div>
              </div>
              <div className='formcol'>&nbsp;</div>
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onSelectAddress (addressType) {
    let address = null

    if (this.state.addresses && this.state.addresses.length > 0) {
      address = _.find(
        this.state.addresses,
        address => address.type.toLowerCase() === addressType
      )
    }

    this.setState({ address: address, dataDate: new Date() })
  }

  _getAddress (addresses) {
    let address = addresses[0]

    if (addresses && addresses.length > 0) {
      addresses.map(addressObj => {
        if (addressObj.type.toLowerCase() === 'po') {
          address = addressObj
        }
      })
    }

    return address
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onFormSubmit (ev) {
    ev.preventDefault()
    let contactPerson = null
    if (
      this.state.contactPersonId &&
      this.state.contactPersonOptions &&
      this.state.contactPersonOptions.length > 0
    ) {
      contactPerson = _.find(this.state.contactPersonOptions, contact => {
        return contact.value === this.state.contactPersonId
      })
    }

    const poObj = {
      contactPerson: contactPerson ? contactPerson.obj : null,
      contactAddress: this.state.address ? this.state.address : '',
      status: 'Open'
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(poObj)
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.props.setAddressNotChecked(false)
    this.hide()
  }

  _onClickEditAddress (e) {
    e.preventDefault()

    if (this.props.onEditAddress) {
      this.props.onEditAddress(e)
    }
  }
}

export default DialogPurchaseOrderOpen
